document.addEventListener('DOMContentLoaded',()=>{


    $('#contactRequest').submit(function(e){
        e.preventDefault();
        $('#result').empty();
        var send = true;
        if($(this).find('textarea[name=text]').val().toString().trim() == ''){
            send = false;
            $(this).find('textarea[name=text]').addClass('is-invalid');
        }
        else{
            $(this).find('textarea[name=text]').removeClass('is-invalid');
        }

        if($(this).find('input[name=name]').val().toString().trim() == ''){
            send = false;
            $(this).find('input[name=name]').addClass('is-invalid');
        }
        else{
            $(this).find('input[name=name]').removeClass('is-invalid');
        }

        if($(this).find('input[name=email]').val().toString().trim() == ''){
            send = false;
            $(this).find('input[name=email]').addClass('is-invalid');
        }
        else{
            $(this).find('input[name=email]').removeClass('is-invalid');
        }

        if( send ) {

            $.ajax({
                url: 'ajaxRequest/contact/request',
                method: 'POST',
                dataType: 'json',
                data: {
                    text: $(this).find('textarea[name=text]').val(),
                    name: $(this).find('input[name=name]').val(),
                    email: $(this).find('input[name=email]').val(),
                    tel: $(this).find('input[name=phone]').val(),
                    subscribe_newsletter: $(this).find('input[name=subscribe_newsletter]').is(':checked'),
                    aszf: $(this).find('input[name=cc2]').is(':checked')
                },
                success: function (msg) {
                    if(msg.result == "success") {
                        var div = '<div class="alert alert-success"><a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>';
                    }
                    else{
                        var div = '<div class="alert alert-danger"><a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>';
                    }
                    div += msg.data;
                    div += '</div>';
                    $('#result').append(div);
                    if(msg.result == "success") {
                        $('#contactRequest')[0].reset();
                    }
                }
            })
        }

    })



    $('.panorama a').click(function () {
        let row = $('.panorama .row');
        let iframe =  $('.panorama iframe');

        row.addClass('d-none');
        iframe.removeClass('d-none');
    })
})